import { getGlobalEventMergeId } from '../../_common/client/tracking';
import { DataContainer, Feature, submitEventMerge, submitMerge } from '@otto-ec/tracking-bct';
import { trackView } from '@otto-ec/nexus-registry/pdp/tracking';

export class ViewTracking {
    public init(): void {
        trackView.assignFunction((dataContainer, features?: Feature[]) => {
            this.submitView(dataContainer, features);
        });
    }

    private submitView(trackingData: DataContainer, features?: Feature[]) {
        if (o_product.state.isVariationChanged) {
            const eventMergeId = getGlobalEventMergeId();
            if (eventMergeId) {
                submitEventMerge(eventMergeId, trackingData, features ? { name: 'change', features } : undefined);
            }
        } else {
            submitMerge(trackingData, features);
        }
    }
}
